import React, { useEffect, useState } from "react";
import { Animated, Dimensions, Platform, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, TextAlignTokens } from "@voltmoney/schema";
import ThemeProvider from '@voltmoney/theme';
import { ModalAlignmentEnum } from "@voltmoney/types";
import BottomSheet from "../BottomSheet";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Space } from "../../space/Space";
import LottieView from "lottie-react-native";
import { Button } from "../../button/Button";
import Image from '../../image/Image';
import { isMobile } from "../../stack/utils";
import { getScreenType } from "../bankSelectPage/BankSelect";
import CustomHeader from "../../customHeader/CustomHeader";
import TextInputDLS from "../../textInputDLS/textInputDLS";
import { isFromTDLPlatform } from "../utils";
const BankAdd = ({ bankData, profileAction, skipBankAction, userName, backAction, addBankAction, sharedPropService, accountNumberValue, ifscValue, triggerAction, applyAction, modalState, bankCode, continuePress, bankName, height, moveToBankAddScreen, errorTitle, errorSubtitle, errorModalCtaLabel, needHelpAction, loading, }) => {
    const [SlideInLeft, setSlideIn] = useState(new Animated.Value(0));
    const [showModal, setShowModal] = useState(false);
    const [rupeeLottie, setRupeeLottie] = useState("");
    const [selectedValue, setSelectedValue] = useState("");
    const [cardState, setModalState] = useState("Penny");
    const [modalHeight, setModalHeight] = useState(modalState === 'error' ? 244 : 342);
    const [selectedObject, setSelectedObject] = useState({});
    const [successLottie, setSuccessLottie] = useState("");
    const [isDismissable, setDismissable] = useState(false);
    const [accountNumber, setAccountNumber] = useState("");
    const [ifscNumber, setIfsc] = useState("");
    const [buttonActive, setButtonActive] = useState(false);
    const [inputActive, setInputActive] = useState(true);
    const theme = ThemeProvider.getTheme();
    const fontFamilyMapping = theme.fontFamily;
    const colorMapping = theme.colors;
    useEffect(() => {
        setInputActive(true);
        console.warn("IFSC VALUE RECEIVED", ifscValue, accountNumberValue);
        if (ifscValue && ifscValue !== '') {
            setButtonActive(true);
        }
        else {
            setButtonActive(false);
        }
    }, [ifscValue, accountNumberValue]);
    const _start = () => {
        return Animated.timing(SlideInLeft, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true
        }).start();
    };
    useEffect(() => {
        if (modalState) {
            if (modalState === 'ifsc') {
                setModalHeight(228);
                setDismissable(false);
            }
            if (modalState === 'error') {
                setModalHeight(244);
                setDismissable(true);
            }
            if (modalState === "success") {
                setModalHeight(228);
            }
            if (modalState === "penny") {
                setModalHeight(342);
                setDismissable(false);
            }
            setModalState(modalState);
        }
        else {
            setModalState("Penny");
            setDismissable(false);
        }
    }, [modalState]);
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: { padding: 16, alignItems: "center", flex: 1 } },
            React.createElement(LottieView, { source: successLottie, style: { width: 70, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 16, marginBottom: 4 } },
                React.createElement(Typography, { label: "Account verified successfully", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "You will be redirected to next step in few seconds", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 32 })),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, width: '100%', paddingHorizontal: 16, marginBottom: 12 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Continue", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (continuePress) {
                            triggerAction(continuePress);
                        }
                    } }))));
    };
    const renderErrorContent = () => {
        return (React.createElement(View, { style: { padding: 16, alignItems: "center", flex: 1 } },
            React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { label: errorTitle ? errorTitle : "Invalid bank account", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, paddingTop: 32 })),
            errorSubtitle &&
                React.createElement(React.Fragment, null,
                    React.createElement(View, { style: {
                            marginTop: 16,
                            backgroundColor: '#FEF4E6',
                            width: '100%',
                            padding: 8,
                            borderRadius: 8
                        } },
                        React.createElement(Typography, { textAlign: TextAlignTokens.center, label: errorSubtitle, fontSize: FontSizeTokens.SM, fontWeight: '400', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Charcoal, paddingTop: 32 })),
                    React.createElement(View, { style: { height: 16 } })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                    paddingBottom: 8,
                    marginBottom: 12
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: errorModalCtaLabel ? errorModalCtaLabel : "Add another bank account", width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, onPress: () => {
                        if (profileAction) {
                            triggerAction(moveToBankAddScreen);
                        }
                    } }))));
    };
    const renderPennyDropContent = () => {
        return (React.createElement(View, { style: { padding: 16, alignItems: "center", flex: 1 } },
            Platform.OS === 'ios' && React.createElement(LottieView, { source: { uri: "https://lottie.host/78420adf-df0a-4fa2-a500-36bbf2ac0762/YkUlAx1j0n.json" }, style: { width: 99, height: 99, }, autoPlay: true, loop: true }),
            Platform.OS !== 'ios' &&
                React.createElement(LottieView, { source: rupeeLottie, style: { width: 99, height: 'auto' }, autoPlay: true, loop: true }),
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, label: "Depositing ₹1", fontWeight: 'bold', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, paddingTop: 16 }),
            React.createElement(View, { style: { width: '100%', backgroundColor: '#FEF4E6', padding: 16, marginTop: 24, borderRadius: 8 } },
                React.createElement(Text, { style: {
                        textAlign: 'center',
                        fontFamily: isFromTDLPlatform() ? 'InterSimonson' : fontFamilyMapping.Inter,
                        fontSize: 14,
                        color: '#1D2939',
                        fontWeight: '400',
                        lineHeight: 20
                    } },
                    "To verify account, we will deposit \u20B91 and match account holder name with name as per PAN \"",
                    React.createElement(Text, { style: [styles.boldText, { fontFamily: isFromTDLPlatform() ? 'InterSimonson' : fontFamilyMapping.Inter,
                            }] }, userName),
                    "\".")),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: 14 } },
                React.createElement(Typography, { label: "It may take up to 30 seconds..." }))));
    };
    const renderInvalidIfscContent = () => {
        return (React.createElement(View, { style: { padding: 16, alignItems: "center", flex: 1 } },
            React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "Selected bank account does not \n support digital mandate", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, paddingTop: 32 })),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, width: '100%', paddingHorizontal: 16 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Change bank account", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (addBankAction) {
                            triggerAction(addBankAction);
                        }
                    } }),
                React.createElement(View, { style: { height: 12 } }),
                React.createElement(View, { style: { marginBottom: 12 } }))));
    };
    const modalContentPresenter = () => {
        switch (cardState) {
            case "Penny": {
                return renderPennyDropContent();
                break;
            }
            case "success": {
                return renderVerificationSuccess();
                break;
            }
            case "ifsc": {
                return renderInvalidIfscContent();
                break;
            }
            case "error": {
                return renderErrorContent();
                break;
            }
            default: {
                return renderPennyDropContent();
                break;
            }
        }
    };
    useEffect(() => {
        fetch("https://lottie.host/78420adf-df0a-4fa2-a500-36bbf2ac0762/YkUlAx1j0n.json", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setRupeeLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        fetch("https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setSuccessLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
        console.warn("BANK DATA RECEIVED IS", bankData);
        _start();
        return () => {
            modalState === 'error' ? setModalHeight(244) : setModalHeight(332);
            setModalState('Penny');
            setShowModal(false);
            setDismissable(false);
        };
    }, []);
    return (React.createElement(View, { style: [styles.container, { height: Platform.OS === "ios" ? height - 16 : height }] },
        React.createElement(View, { style: styles.contentContainer },
            React.createElement(View, { style: styles.header },
                React.createElement(CustomHeader, { title: "Enter account details", needHelpAction: needHelpAction, goBackAction: backAction, goBackId: "btn_bankAdd_goBack", needHelpId: "btn_bankAdd_needHelp", triggerAction: triggerAction })),
            React.createElement(View, { style: { flexDirection: 'row', marginTop: 24, justifyContent: 'space-between', } },
                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                    React.createElement(Image, { uri: `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode}.png`, defaultUri: "https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png", size: ImageSizeTokens.SIZE_42 }),
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontWeight: "600", label: bankName })),
                React.createElement(View, { nativeID: "bt_addBankPage_editBank", style: { justifyContent: 'center', alignItems: 'center' } },
                    React.createElement(TouchableOpacity, { onPress: () => {
                            if (addBankAction) {
                                triggerAction(addBankAction);
                            }
                        }, style: { justifyContent: 'center', alignItems: 'center' } },
                        React.createElement(Icon, { name: IconTokens.Edit, size: IconSizeTokens.XXL })))),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(TextInputDLS, { nativeID: 'tf_addBankPage_enterAccountNumber', label: "Account number", holder: "Enter account number", value: accountNumber, autoFocus: false, onChangeText: (text) => {
                        const sanitizedText = text.replace(/\s+/g, '');
                        sharedPropService.setAccountNumber(sanitizedText);
                        setAccountNumber(sanitizedText);
                        if ((ifscValue && ifscValue !== '') && (sanitizedText !== '')) {
                            setButtonActive(true);
                        }
                        else {
                            setButtonActive(false);
                        }
                    } })),
            React.createElement(View, { style: { marginTop: 20 } },
                React.createElement(TextInputDLS, { nativeID: 'tf_addBankPage_searchBranch', label: "IFSC code", holder: "Search by branch or IFSC", value: ifscValue, style: { height: 48 }, onFocus: () => {
                        if (profileAction) {
                            triggerAction(profileAction);
                        }
                    } }))),
        React.createElement(View, { nativeID: "bt_addBankPage_verifyBankAccount", style: {
                position: 'absolute',
                bottom: 0,
                width: '100%',
                justifyContent: 'center',
                borderTopWidth: 1,
                borderColor: '#F1F3F5',
                paddingHorizontal: -16,
                paddingVertical: 8,
                backgroundColor: 'white',
                ...Platform.OS === 'ios' && {
                    paddingBottom: 4
                }
            } },
            React.createElement(View, { style: { alignContent: 'center', alignItems: 'center', marginTop: 8 } },
                React.createElement(Typography, { label: "We'll match account holder name with PAN records", fontSize: FontSizeTokens.XS, fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter })),
            React.createElement(View, { style: styles.bottomCTA },
                React.createElement(Button, { id: "bt_bankVerification_verifyBankAccount", type: buttonActive && accountNumber ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: "Verify bank account", loading: loading, onPress: () => {
                        if (applyAction && !loading) {
                            setModalHeight(modalState === "error" ? 244 : 340);
                            setShowModal(true);
                            triggerAction(applyAction);
                        }
                        else
                            setShowModal(false);
                    } }))),
        showModal &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    zIndex: 1.5
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: Platform.OS === 'web'
                        && isMobile(getScreenType(Dimensions.get('window').width)) ?
                        Dimensions.get('window').height - 70
                        : Platform.OS === 'web'
                            && !isMobile(getScreenType(Dimensions.get('window').width)) ?
                            Dimensions.get('window').height - 114 :
                            Platform.OS === 'android'
                                ? height : isMobile(getScreenType(Dimensions.get('window').width))
                                ? Platform.OS === "ios" ? height - 14 : height - 34
                                : Dimensions.get('window').height - 114, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modalContentPresenter()))));
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 114,
        marginHorizontal: -16
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    header: { marginHorizontal: -16 },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        paddingHorizontal: 16,
        ...Platform.OS === 'ios' && { marginTop: 24 },
        flex: 1 // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14
    },
    bottomCTA: {
        paddingHorizontal: 16,
        marginTop: 8,
        marginBottom: 6,
        ...Platform.OS === "ios" && {
            paddingBottom: 12,
            marginTop: 12
        }
    }
});
export default (BankAdd);
